import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

function Reddit({ style }: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      height="31"
      style={style}
      viewBox="0 0 30 31"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7981_7683)">
        <circle cx="15" cy="15.5" fill="#FF4500" r="15" />
        <path
          d="M17.5427 8.06221C17.7594 8.98106 18.5842 9.66555 19.5691 9.66555C20.7189 9.66555 21.6511 8.73304 21.6511 7.58278C21.6511 6.43251 20.7189 5.5 19.5691 5.5C18.5637 5.5 17.7252 6.21281 17.53 7.16095C15.8463 7.34159 14.5315 8.77014 14.5315 10.5014C14.5315 10.5053 14.5315 10.5082 14.5315 10.5121C12.7003 10.5893 11.0283 11.1107 9.70083 11.9339C9.20791 11.5521 8.58907 11.3245 7.91752 11.3245C6.306 11.3245 5 12.631 5 14.2432C5 15.413 5.68716 16.4207 6.67984 16.8864C6.77648 20.2747 10.4671 23 15.0068 23C19.5466 23 23.2421 20.2718 23.3338 16.8806C24.3187 16.4119 25 15.4071 25 14.2441C25 12.632 23.694 11.3255 22.0825 11.3255C21.4139 11.3255 20.798 11.5511 20.306 11.9299C18.9668 11.1009 17.2762 10.5795 15.4265 10.5102C15.4265 10.5073 15.4265 10.5053 15.4265 10.5024C15.4265 9.26228 16.348 8.23309 17.5427 8.06417V8.06221ZM9.5837 16.0955C9.6325 15.037 10.3353 14.2246 11.1523 14.2246C11.9693 14.2246 12.5939 15.0829 12.5451 16.1414C12.4963 17.1999 11.8863 17.5846 11.0683 17.5846C10.2504 17.5846 9.5349 17.154 9.5837 16.0955ZM18.8624 14.2246C19.6803 14.2246 20.3831 15.037 20.4309 16.0955C20.4797 17.154 19.7633 17.5846 18.9463 17.5846C18.1293 17.5846 17.5183 17.2008 17.4695 16.1414C17.4207 15.0829 18.0444 14.2246 18.8624 14.2246ZM17.8902 18.5444C18.0434 18.5601 18.141 18.7192 18.0815 18.8618C17.5788 20.0638 16.3919 20.9084 15.0068 20.9084C13.6218 20.9084 12.4358 20.0638 11.9322 18.8618C11.8726 18.7192 11.9702 18.5601 12.1235 18.5444C13.0215 18.4536 13.9927 18.4038 15.0068 18.4038C16.021 18.4038 16.9912 18.4536 17.8902 18.5444Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7981_7683">
          <rect
            fill="white"
            height="30"
            transform="translate(0 0.5)"
            width="30"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Reddit;
